<template>
  <div class="staff-carousel">
    <carousel
      :nav="false"
      :items="4"
      :mouseDrag="false"
      :responsive="{
        0: { items: 1, nav: true, touchDrag: false, },
        576: { items: 3, nav: false }
      }"
      @changed="changeClass"
    >
      <div
        class="text-center"
        v-for="(item) in classes"
        :key="item.classIndex"
      >
        <div
          class="item"
          :class="{ active: item.isActive }"
          @click="classSelect(item)"
        >
          <img :src="`/${$staticPath}/${item.img}`" />
        </div>
        <span>{{ item.name }}</span>
      </div>
    </carousel>
  </div>
</template>

<script>
import carousel from 'vue-owl-carousel'

export default {
  components: {
    carousel
  },
  props: ['classesProp'],
  data () {
    return {
      classes: {}
    }
  },
  created () {
    this.classes = this.classesProp
  },
  methods: {
    classSelect: function (item) {
      this.classes.map((el) => {
        el.isActive = false
      })
      item.isActive = true
      this.$emit('selectClass', item.path)
    },
    changeClass: function (event) {
      if (window.innerWidth < 576) {
        var item = this.classes[event.item.index]
        this.classes.map((el) => {
          el.isActive = false
        })
        item.isActive = true
        this.$emit('selectClass', item.path)
      }
    }
  }
}
</script>

<style scoped>
  @import url('../../../static/css/staff-style/carousel.css');
</style>



// WEBPACK FOOTER //
// src/components/STAFF/Carousel.vue